var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Injectable } from '@angular/core';
import { NGXLogger } from 'ngx-logger';
import { ApiService } from '../../service/api.service';
import { ContentBaseService } from '../base/contentbase.service';
import { ConditionService } from '../../service/condition.service';
import { BehaviorSubject } from 'rxjs';
export var Direction;
(function (Direction) {
    Direction.asc = 'asc';
    Direction.desc = 'desc';
})(Direction || (Direction = {}));
var OrderBy = /** @class */ (function () {
    function OrderBy() {
        this.direction = Direction.asc;
    }
    return OrderBy;
}());
export { OrderBy };
var Predicate = /** @class */ (function () {
    function Predicate() {
        this.type = 'string';
        this.operator = 'eq';
    }
    return Predicate;
}());
export { Predicate };
var Query = /** @class */ (function () {
    function Query() {
        this.limit = 10;
        this.page = 1;
        this.orderByList = [];
        this.predicateList = [];
    }
    return Query;
}());
export { Query };
var RequestQuery = /** @class */ (function () {
    function RequestQuery() {
        this.limit = 10;
        this.offset = 0;
        this.orderByList = [];
        this.predicateList = [];
    }
    return RequestQuery;
}());
export { RequestQuery };
var Pager = /** @class */ (function () {
    function Pager() {
    }
    return Pager;
}());
export { Pager };
var ConditionQuery = /** @class */ (function () {
    function ConditionQuery() {
        this.limit = 10;
        this.page = 1;
        this.orderByList = [];
        this.searchRec = {};
    }
    return ConditionQuery;
}());
export { ConditionQuery };
var ListService = /** @class */ (function (_super) {
    __extends(ListService, _super);
    function ListService(logger, api, cond) {
        var _this = _super.call(this, logger, api) || this;
        _this.logger = logger;
        _this.api = api;
        _this.cond = cond;
        _this.condFlg = false;
        _this.baseGroupName = '$baseGroup';
        _this.bulkPrimaryKeys = {};
        _this.bulkClear = {};
        _this.bulkRecs = {};
        _this.bulkIds = {};
        return _this;
    }
    ListService.prototype.initQuery = function () {
        this.query = {};
        this.condQuery = {};
        this.condFlg = false;
        this.saveQuery = {};
        this._bulkSubject = new BehaviorSubject({});
        this.bulkPrimaryKeys = {};
        this.bulkClear = {};
        this.bulkRecs = {};
        this.bulkIds = {};
        var cond = this.cond.getCondition();
        if (typeof cond !== 'undefined') {
            this.condQuery = cond;
            this.condFlg = true;
        }
    };
    ListService.prototype.getGroupName = function (groupName) {
        if (groupName === void 0) { groupName = ''; }
        var name = groupName ? groupName : this.baseGroupName;
        if (typeof this.query[name] === 'undefined') {
            this.query[name] = new Query();
        }
        if (typeof this.condQuery[name] === 'undefined') {
            this.condQuery[name] = new ConditionQuery();
        }
        return name;
    };
    ListService.prototype.setSaveQuery = function (groupName, saveQuery) {
        if (typeof this.saveQuery[groupName] === 'undefined') {
            this.saveQuery[groupName] = true;
        }
        this.saveQuery[groupName] = this.saveQuery[groupName] && (saveQuery === false ? false : true);
        return this.saveQuery[groupName];
    };
    ListService.prototype.convertQuery = function (query) {
        return {
            limit: query.limit,
            offset: (query.page - 1) * query.limit,
            orderByList: query.orderByList,
            predicateList: query.predicateList
        };
    };
    ListService.prototype.getQuery = function (query, groupName) {
        if (query === void 0) { query = {}; }
        groupName = this.getGroupName(groupName);
        if (typeof query !== 'undefined') {
            for (var key in this.query[groupName]) {
                if (typeof query[key] !== 'undefined') {
                    this.query[groupName][key] = query[key];
                    this.condQuery[groupName][key] = query[key];
                }
            }
        }
        delete this.condQuery[groupName]['predicateList'];
        this.setConditionQuery();
        return this.convertQuery(this.query[groupName]);
    };
    ListService.prototype.getCurrentQuery = function (groupName) {
        var query = this.query[groupName];
        return {
            limit: query.limit,
            page: query.page,
            orderByList: query.orderByList,
            predicateList: query.predicateList
        };
    };
    ListService.prototype.setConditionQuery = function () {
        this.cond.setCondition(this.getConditionQuery());
    };
    ListService.prototype.setCondition = function (data, groupName, key) {
        if (data === void 0) { data = {}; }
        if (key === void 0) { key = 'searchRec'; }
        this.condQuery[groupName][key] = JSOG.parse(JSON.stringify(data));
        this.cond.setCondition(this.getConditionQuery());
    };
    ListService.prototype.getCondition = function (groupName) {
        var condQuery;
        if (this.condFlg && typeof this.condQuery[groupName] !== 'undefined') {
            condQuery = this.condQuery[groupName];
        }
        return condQuery;
    };
    ListService.prototype.getConditionQuery = function () {
        var condQuery = JSOG.parse(JSON.stringify(this.condQuery));
        for (var _i = 0, _a = Object.keys(this.saveQuery); _i < _a.length; _i++) {
            var groupName = _a[_i];
            if (!this.saveQuery[groupName] && condQuery[groupName]) {
                delete condQuery[groupName];
            }
        }
        return condQuery;
    };
    Object.defineProperty(ListService.prototype, "bulkObservable", {
        get: function () {
            return this._bulkSubject.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    ListService.prototype.setBulk = function (groupName, recs) {
        var data = {};
        data[groupName] = recs;
        this._bulkSubject.next(data);
    };
    ListService.prototype.setBulkPrimaryKey = function (groupName, key) {
        this.bulkPrimaryKeys[groupName] = key;
    };
    ListService.prototype.getBulkPrimaryKey = function (groupName) {
        return this.bulkPrimaryKeys[groupName] || null;
    };
    ListService.prototype.setBulkClear = function (groupName, flg) {
        this.bulkClear[groupName] = flg;
    };
    ListService.prototype.getBulkClear = function (groupName) {
        return (typeof this.bulkClear[groupName] === 'undefined' ? true : this.bulkClear[groupName]);
    };
    ListService.prototype.clearBulkRecs = function (groupName) {
        this.bulkRecs[groupName] = [];
        this.bulkIds[groupName] = [];
    };
    ListService.prototype.getBulkRecs = function (groupName) {
        return this.bulkRecs[groupName] || [];
    };
    ListService.prototype.getBulkIds = function (groupName) {
        return this.bulkIds[groupName] || [];
    };
    ListService.prototype.mergeBulkRecs = function (groupName, recs, checkData) {
        var primaryKey = this.getBulkPrimaryKey(groupName);
        if (!primaryKey) {
            this.bulkRecs[groupName] = recs;
            this.bulkIds[groupName] = [];
            return recs;
        }
        var bulkRecs = this.getBulkRecs(groupName);
        var bulkIds = this.getBulkIds(groupName);
        for (var _i = 0, recs_1 = recs; _i < recs_1.length; _i++) {
            var rec = recs_1[_i];
            var id = rec[primaryKey];
            if (bulkIds.indexOf(id) == -1) {
                bulkRecs.push(rec);
                bulkIds.push(id);
            }
        }
        for (var i = bulkRecs.length - 1; i >= 0; i--) {
            var rec = bulkRecs[i];
            var id = rec[primaryKey];
            if (checkData[id] === false) {
                bulkRecs.splice(i, 1);
                var index = bulkIds.indexOf(id);
                if (index >= 0) {
                    bulkIds.splice(index, 1);
                }
            }
        }
        this.bulkRecs[groupName] = bulkRecs;
        this.bulkIds[groupName] = bulkIds;
        return this.bulkRecs[groupName];
    };
    ListService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    ListService.ctorParameters = function () { return [
        { type: NGXLogger },
        { type: ApiService },
        { type: ConditionService }
    ]; };
    return ListService;
}(ContentBaseService));
export { ListService };
//# sourceMappingURL=list.service.js.map